// ============================================================
// GAME CONSTANTS — change these to tweak gameplay
// ============================================================

export const GRID_SIZE = 8;           // changed from 16 to 8
export const MAX_EP = 350;
export const START_EP = 175;
export const MONEY_VAL = 50;
export const BURGER_EP = 35;
export const APPLE_EP = 20;
export const BASE_EP_COST = 1;
export const LEVEL_UP_SECONDS = 30;

export const ITEM_COUNTS = {
  '💰': 2,   // fewer items fit on 8x8
  '🍔': 1,
  '🍎': 1,
};

export const AVATARS = [
  { id: 1, emoji: '🧑‍💻', bg: '#845EC2', label: 'Techy Guy'   },
  { id: 2, emoji: '👧',    bg: '#FF6B9D', label: 'Curly Girl'  },
  { id: 3, emoji: '🧔',    bg: '#4D96FF', label: 'Cool Dude'   },
  { id: 4, emoji: '👩‍🦰', bg: '#FF6B35', label: 'Fierce Girl' },
  { id: 5, emoji: '🧑‍🎮', bg: '#6BCB77', label: 'Gamer'       },
  { id: 6, emoji: '👩‍🎨', bg: '#FFD93D', label: 'Artist'      },
  { id: 7, emoji: '🧑‍🚀', bg: '#FF4060', label: 'Astronaut'   },
  { id: 8, emoji: '👩‍💻', bg: '#00C9A7', label: 'Dev Girl'    },
];

export const SOUNDS = {
  bgMusic:  '/sounds/jazz.mp3',
  gameOver: '/sounds/apple_crunch.mp3',
};